import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { LocationProps } from "../../components/settings/location/locationModule";


export type serviceType = {
    loading: boolean,
    error: string | null
}

export type OrderJson =
    {
        result: { count: number, rows: OrderType[] | null },
        "msg": string,
        "statusCode": string,
        "success": boolean
    } | null


export type updateDiscountJson = {
    "data": {
        "getOneOrderDetails": {
            "getOrderDetails": {
                "orderDetails": {
                    "amountPaid": string,
                    "customerId": number,
                    "customizedOrderId": string,
                    "deliveredDate": string,
                    "deliveryAddress": {
                        "countryCode": number,
                        "phone": string
                    },
                    "extraAmount": number,
                    "id": number,
                    "isDigitalOrder": boolean,
                    "isPreOrder": boolean,
                    "isOrderView": boolean,
                    "isManualOrder": boolean,
                    "isSubscription": boolean,
                    "isZen": boolean,
                    "languageCode": boolean,
                    "locationId": number,
                    "orderComments": string,
                    "orderPluginDetails": [],
                    "orderStatus": number,
                    "orderStatusCode": string,
                    "orderStatusName": string,
                    "prePaidCharges": number,
                    "orderedProducts": [
                        {
                            "combinationName": string,
                            "isPreOrderInStock": boolean,
                            "name": "Brooches",
                            "orderProductId": number,
                            "productId": number,
                            "quantity": number,
                            "variantId": number
                        }
                    ],
                    "paymentOrders": [
                        {
                            "pluginCode": string,
                            "pluginId": string,
                            "status": string,
                            "prepaidAmount": number,
                            "paymentType": string
                        }
                    ],
                    "phoneNumber": string,
                    "shippingType": string,
                    "totalAmount": number,
                    "trackingDetails": string,
                    "trackingId": number
                },
                "userDetails": {
                    "user": {
                        "countryCode": number,
                        "email": string,
                        "firstName": string,
                        "isUserVerified": boolean,
                        "lastName": string,
                        "phone": string
                    }
                }
            }
        }
    }
}
export interface OrderedProduct {
    quantity: number;
    initialQuantity: number;
    actualPrice: number;
    automaticDiscountPrice: number;
    appliedSalesDiscountValue: number;
    modifierPrice: number;
    inclusiveTaxPrice: number;
    availablePreOrderQty: number;
    fbtDiscountPrice: number;
    orderProductId: number;
    productPrice: string;
    name: string;
    productWithOptionPrice: string;
    variantId: number;
    variantName: string;
    productId: number;
    depositAmount: string;
    taxAmount: string;
    appliedDiscountValue: string;
    optionsPrice: string;
    locationId: number;
    isDeleted: boolean;
    orderId: number;
    isPayXProduct: boolean;
    isDigitalProduct: boolean;
    isLinkDisabled: boolean;
    isPreOrderInStock: boolean;
    isInclusiveTax: boolean;
    isFreeProduct: boolean;
    orderedProductsAddOnImages: any[];
    orderedProductsCustomizeDetails: any[];
}

export interface PaymentOrder {
    status: string;
    pluginId: number | null;
    createdAt: string;
    amount: string;
    prepaidAmount: string | null;
    paymentType: string;
}
export interface OrderLog {
    orderStatus: string;
    createdAt: string;
    orderStatusDate: string;
    id: number;
}
export interface DeliveryAddress {
    city: string;
    name: string;
    phone: string;
    state: number;
    country: number;
    zipCode: string;
    landmark: string;
    statename: string;
    countryCode: number;
    countryname: string;
    addressLine1: string;
    addressLine2: string;
    stateIsoCode: string;
    countryIsoCode: string;
}
export interface QuickCheckoutCustomerInfo {
    email: string;
    phone: string;
}
export interface OrderDetails {
    id: number;
    ordersId: string;
    createdAt: string;
    storeId: number;
    isZen: boolean;
    customerId: number;
    locationId: number;

    totalAmount: number;
    serviceCharge: number;
    additionalCharge: number;
    taxAmount: number;
    tipAmount: number;
    orderAmount: number;
    subTotal: number;

    shippingType: string;
    orderStatus: number;

    amountPaid: string;

    deliveryAddress: DeliveryAddress;

    shippingRate: string;

    expectedDate: string;
    deliveredDate: string;

    phoneNumber: string;

    serialOrderId: number;
    orderIdPrefixText: string;
    orderIdSuffixText: string;

    isDigitalOrder: boolean;
    isPreOrder: boolean;
    isSubscription: boolean;

    platform: string;

    quickCheckoutCustomerInfo: QuickCheckoutCustomerInfo;

    orderedProducts: OrderedProduct[];

    paymentOrders: PaymentOrder[];

    orderLogs: OrderLog[];

    orderStatusName: string;
    orderStatusCode: string;

    customizedOrderId: string;
}
export interface User {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    countryCode: number;
    id: number;
    roleId: number;
    isUserVerified: boolean;
    isActive: boolean;
}

export interface UserDetails {
    userId: number;
    isWholesale: boolean;
    isApproved: boolean;
    user: User;
}
export interface GetOrderDetailsResponse {
    getOrderDetails: {
        orderDetails: OrderDetails;
        userDetails: UserDetails;
    };
    message: string;
    statusCode: string;
    success: boolean;
}

export interface LocationWithSelected extends LocationProps {
    selected: boolean;
}

export type orderListPayLoad =
    {
        offset?: number,
        limit?: number,
        locationId?: number,
        searchValue?: string,
        filterData?: any,
        sortOrder?: string,
        serialOrderId?: any,
        isPos?: boolean
    }

export type updateOrderPayload = {
    // customerId: number | null
    customizedOrderId: string | null
    // isQuickEdit: boolean
    // isStatusChanged: boolean
    modifiedAt: Date
    orderComments?: string
    orderId: number
    orderName: string | null
    orderStatusCode: string
    orderStatusDate: Date
    storeId: number
    todayDate: string
    // trackingId: number | null
    userEmail: string
    event: string
    isPreOrder: false
    orderStatus: number
}

export type OrderType =
    {
        "availableValueToRedeem": number | null,
        "codAmount": number,
        "createdAt": string,
        "customerId": number,
        "customizedOrderId": string,
        "deliveredDate": string | null,
        "id": number,
        "isDigitalOrder": boolean,
        "isManualOrder": boolean,
        "isOrderView": boolean,
        "isPreOrder": boolean,
        "isSubscription": boolean,
        "isWholesale": boolean,
        "isZen": boolean,
        "locationId": number,
        "modifiedAt": string,
        "orderComments": string,
        "orderIdPrefixText": string,
        "orderIdSuffixText": string,
        "orderStatus": string,
        "orderStatusCode": string,
        "orderStatusId": number,
        "paymentId": number,
        "paymentPluginId": string | null,
        "paymentStatus": string,
        "phoneNumber": string,
        "serialOrderId": 1625,
        "shippingType": string,
        "stockRestored": boolean,
        "storeId": number,
        "totalAmount": number,
        "totalOrderAmount": string,
        "trackingId": string | null | number,
        "usedGiftCardAmount": number,
        "userCountryCode": number,
        "userEmail": string,
        "userFirstName": string,
        "userLastName": string,
        "userPhone": string,
        "selectedList"?: boolean
    }


export type LocationJson =
    {
        inventoryLocation: locationtype[]
    }
export type locationtype =
    {
        "id": number,
        "addressId"?: number | undefined,
        "locationName": string,
        "pickupInstructions"?: any,
        "locationDescription"?: any,
        "latitude"?: null,
        "longitude"?: null,
        "storeId"?: number | undefined,
        "shopClosedDays"?: null,
        "timeZone"?: string,
        "isOrderSpecificTiming"?: null,
        "orderAmountLimit"?: null,
        "maximumOrderAmountLimit"?: null,
        "isDefault"?: boolean,
        "isGlobal"?: null,
        "allowedZipcodes"?: null,
        "isActive"?: boolean,
        "locationNameJson"?: null,
        "storeWorkingHours"?: [
            {
                "id": null,
                "productBoxId": null,
                "shippingMethodId": null,
                "startTime": null,
                "endTime": null,
                "sun": null,
                "mon": null,
                "tue": null,
                "wed": null,
                "thu": null,
                "fri": null,
                "sat": null,
                "isDelivery": null,
                "isPickup": null,
                "isOrder": null,
                "isDineIn": null,
                "isStoreActive": null
            }
        ],
        "orderPlacingTimes"?: [
            {
                "id": null,
                "startTime": null,
                "endTime": null,
                "sun": null,
                "mon": null,
                "tue": null,
                "wed": null,
                "thu": null,
                "fri": null,
                "sat": null,
                "isStoreActive": null
            }
        ]
        "selected"?: boolean,
        "search"?: boolean
    } | null

export type Filter = {
    paymentstatus?: string | null;
    fullfillmentStatus?: string | null;
    postorderstatus?: string | null;
    shippingtype?: string | null;

    customDate?: {
        startDate: string;
        endDate: string;
    } | null;

    paymentmethod?: string | null;
    ordertype?: string | null;

    pickedUpordeliveryDate?: {
        startDate: string;
        endDate: string;
    } | null;

    savedFilterId?: string | null;
} | null;

export type SavedFilterOption = {
    id: string; filterName: string; filterType: any; filterValue: { value: string; label: string; }[]; initialSelected: string;
}
const limit = 10

export type OrdersStackParamList = {
    OrderList: { customerId: number, isPos: boolean };
};

export type deleteOrderJson =
    {
        "orderDeletion": {
            "removableOrders": number[]
        },
        "message": String,
        "statusCode": String,
        "success": boolean
    }

export type updateResponse =
    {
        "statusCode": string,
        "message": string,
        "success": boolean
    }


export type deleteOrderPayload =
    {
        orderId: string
    }

export type savedFilterPayload =
    {
        code: string
    }

export type savedFilterJson =
    {
        "savedFilters": filterType[]
    }

export type saveFilterItems = {
    filterName: string
}
export type filterType =
    {
        "id": number,
        "filterPredicate": {
            "savedFilterName": string | null,
            "status": string | null,
            "value": string | null,
            "paymentMethod": string | null,
            "deliveryType": string | null,
            "customDateRange": {
                "begin": string | null,
                "end": string | null
            },
            "days": string | null,
            "orderType": {
                "isManualOrder": boolean | null,
                "isZen": boolean | null,
                "isSubscription": boolean | null,
                "isPreOrder": boolean | null,
                "isDigitalOrder": boolean | null
            },
            "deliveryDate": {
                "begin": string | null,
                "end": string | null
            }
        },
        "savedFilterNames": [
            {
                "Title": string,
                "Value": string
            }
        ],
        "filterName": string,
        "filterCode": string | null,
        "createdAt": string | null,
        "modifiedAt": string | null,
        "isDeleted": boolean,
        "storeId": number
    }

export type postFilterPayload =
    {
        "filterName": string | null,
        "code": string | null,
        "filterPredicate": {
            "savedFilterName": string | null,
            "status": string | null,
            "value": number,
            "paymentMethod": string | null,
            "deliveryType": string | null,
            "customDateRange": {
                "begin": string | null,
                "end": string | null
            },
            "orderType": {
                isManualOrder?: boolean | null,
                isZen?: boolean | null,
                isSubscription?: boolean | null,
                isPreOrder?: boolean | null,
                isDigitalOrder?: boolean | null
            },
            "deliveryDate": {
                "begin": string | null,
                "end": string | null
            }
        },
        "savedFilterNames": filterNameType[]
    }

export type filterNameType =
    {
        "Title": string | null,
        "Value": string | null
    }

export type postFilterJson =
    {
        "success": boolean,
        "code": string,
        "message": string
    }

export type filterPropertiesJson =
    {
        "propertyValueData": {
            "propertyName": string,
            "code": "POS_ORDER_STATUS" | "POS_PAYMENT_STATUS" | "POST_ORDER_STATUS" | "ORDER_STATUS" | "PAYMENT_STATUS",
            "id": number,
            "propertyValues": propertiesType[]
        }[],
        "code": "fetch-property-values-010",
        "message": "Property values data record fetch success",
        "success": true
    }

export type propertiesType =
    {
        "value"?: string,
        "code"?: string,
        "id": number,
        "additionalField"?: number,
        "translateJsonField"?: {
            "ta": string
        },
        "nameofcontent"?: string
    }

export interface RestoreOrderResponse {
    "result": {
        "count": number,
        "rows": []
    },
    "msg": string,
    "statusCode": string,
    "success": boolean
}

interface initialState {
    getAllOrders: serviceType & { value: OrderType[], count: number },
    posOrders: serviceType & { value: OrderType[], count: number },
    onlineOrders: serviceType & { value: OrderType[], count: number },
    getAllInventoryLocations: serviceType & { value: OrderJson | null },
    updateOrderDetails: serviceType & { value: updateResponse | null },
    deleteOrder: serviceType & { value: deleteOrderJson | null },
    getSavedFilter: serviceType & { value: savedFilterJson | null },
    postFilter: serviceType & { value: postFilterJson | null },
    deleteFilter: serviceType & { value: postFilterJson | null },
    filterProperties: serviceType & { value: filterPropertiesJson | null }

}

const intialState: initialState =
{
    getAllOrders: { error: null, value: [], loading: false, count: 0 },
    posOrders: { error: null, value: [], loading: false, count: 0 },
    onlineOrders: { error: null, value: [], loading: false, count: 0 },
    getAllInventoryLocations: { error: null, value: null, loading: false },
    updateOrderDetails: { error: null, value: null, loading: false },
    deleteOrder: { error: null, value: null, loading: false },
    getSavedFilter: { error: null, value: null, loading: false },
    postFilter: { error: null, value: null, loading: false },
    deleteFilter: { error: null, value: null, loading: false },
    filterProperties: { error: null, value: null, loading: false }
}


export const getAllOrdersList = createAsyncThunk("orders/getAllOrdersList", ({ storeId, data, isPos }: { storeId: number, data: orderListPayLoad, isPos: boolean }) => {
    const url = HttpRoutingService?.replaceUrl(isPos ? API?.getAllPosOrdersList : API?.getAllOrdersList, { storeId: storeId })
    return HttpRoutingService?.getMethod<OrderJson>(url, data, isPos ? "v2/" : "v1/")
})

export const getOrderData = createAsyncThunk('orders/getOrderData', ({ storeId, orderId }: { storeId: number, orderId: number }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, { storeId: storeId, id: `${orderId}/details` })
    return HttpRoutingService.getMethod<GetOrderDetailsResponse>(url, '', 'v1/')
})

export const updateOrderDetails = createAsyncThunk('orders/updateOrderDetails', ({ storeId, orderId, data }: { storeId: number, orderId: number | undefined, data: updateOrderPayload }) => {
    const url = HttpRoutingService.replaceUrl(API.singleOrderDetails, { storeId, orderId })
    return HttpRoutingService.putMethod<updateResponse>(url, data)
})

export const restoreOrder = createAsyncThunk('orders/restore', ({ storeId, orderId, isPos }: { storeId: number, orderId: number, isPos: boolean }) => {
    const url = HttpRoutingService.replaceUrl(API.restoreOrder, { storeId, orderId })
    return HttpRoutingService.putMethod<RestoreOrderResponse>(url)
})

export const getAllLocations = createAsyncThunk("orders/getAllInventoryLocations", ({ storeId }: { storeId: number }) => {
    const url = HttpRoutingService.replaceUrl(API.getAllInventoryLocation, { storeId: storeId })
    return HttpRoutingService.getMethod<any>(url, '', 'v2/')
}
)

export const deleteOrder = createAsyncThunk('order/deleteOrder', ({ storeId, orderId }: { storeId: number, orderId: deleteOrderPayload }) => {
    const url = HttpRoutingService.replaceUrl(API.deleteOrder, { storeId: storeId })
    return HttpRoutingService.putMethod<deleteOrderJson>(url, orderId)
})

// export const deleteOrder = createAsyncThunk('order/deleteOrder', ({ storeId, data }: { storeId: number, data: deleteOrderPayload }) => {
//     const url = HttpRoutingService.replaceUrl(API.deleteOrder, { storeId: storeId })
//     return HttpRoutingService.putMethod<deleteOrderJson>(url, data)
// })


export const getSavedFilter = createAsyncThunk('order/getSavedFilter', ({ storeId, data }: { storeId: number, data: savedFilterPayload }) => {
    const url = HttpRoutingService.replaceUrl(API.savedFilter, { storeId: storeId })
    return HttpRoutingService.getMethod<savedFilterJson>(url, data, 'v1/')
}
)

export const postFilter = createAsyncThunk('order/postFilter', ({ storeId, data }: { storeId: number, data: postFilterPayload }) => {
    const url = HttpRoutingService.replaceUrl(API.savedFilter, { storeId: storeId })
    return HttpRoutingService.postMethod<postFilterJson>(url, data)
})

export const deleteFilter = createAsyncThunk('order/deleteFilter', ({ storeId, filterId }: { storeId: number, filterId: number }) => {
    const url = HttpRoutingService.replaceUrl(API.delteFilter, { storeId: storeId, filterId: filterId })
    return HttpRoutingService.deleteMethod<postFilterJson>(url)
})


export const filterProperties = createAsyncThunk('order/filterProperties', ({ data }: { data: { [key: string]: string } }) => {
    return HttpRoutingService.getMethod<filterPropertiesJson>(API.properties, data, 'v2/')
})


const orderSlice = createSlice({
    name: 'order',
    initialState: intialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getAllOrdersList.pending, (state, action) => {
                state.getAllOrders.loading = true
                const isPos = action.meta.arg?.isPos || false
                const targetKey = isPos ? 'posOrders' : 'onlineOrders'
                state[targetKey].loading = true
            })
            .addCase(getAllOrdersList.fulfilled, (state, action) => {
                const offset = action.meta.arg.data?.offset || 0
                const rows = action.payload?.result?.rows || []
                const isPos = action.meta.arg?.isPos || false
                const targetKey = isPos ? 'posOrders' : 'onlineOrders'
                // Keep legacy getAllOrders for backward compatibility if needed, 
                // but primary UI should move to posOrders/onlineOrders
                if (offset > 0) {
                    state.getAllOrders.value = [...state.getAllOrders.value, ...rows]
                    state[targetKey].value = [...state[targetKey].value, ...rows]
                } else {
                    state.getAllOrders.value = rows;
                    state[targetKey].value = rows;
                }
                const count = action?.payload?.result?.count || 0;
                state.getAllOrders.count = count;
                state[targetKey].count = count;
                state.getAllOrders.loading = false;
                state[targetKey].loading = false;
            })
            .addCase(getAllOrdersList.rejected, (state, action) => {
                state.getAllOrders.loading = false
                state.getAllOrders.error = action.error.message as string
                const isPos = action.meta.arg?.isPos || false
                const targetKey = isPos ? 'posOrders' : 'onlineOrders'
                state[targetKey].loading = false
                state[targetKey].error = action.error.message as string
            })


            .addCase(getAllLocations.pending, (state) => {
                state.getAllInventoryLocations.loading = true
            })
            .addCase(getAllLocations.fulfilled, (state, action) => {
                state.getAllInventoryLocations.loading = false
                state.getAllInventoryLocations.value = action.payload
            })
            .addCase(getAllLocations.rejected, (state, action) => {
                state.getAllInventoryLocations.error = action.error.message as string
            })

            .addCase(updateOrderDetails.pending, (state) => {
                state.updateOrderDetails.loading = true
            })
            .addCase(updateOrderDetails.fulfilled, (state, action) => {
                state.updateOrderDetails.loading = false
                state.updateOrderDetails.value = action.payload
            })
            .addCase(updateOrderDetails.rejected, (state, action) => {
                state.updateOrderDetails.loading = false
                state.updateOrderDetails.error = action.error.message as string
            })


            .addCase(deleteOrder.fulfilled, (state, action) => {
                state.deleteOrder.value = action.payload
            })


            .addCase(getSavedFilter.pending, (state) => {
                state.getSavedFilter.loading = true
            })
            .addCase(getSavedFilter.fulfilled, (state, action) => {
                state.getSavedFilter.loading = false
                state.getSavedFilter.value = action.payload
            })
            .addCase(getSavedFilter.rejected, (state, action) => {
                state.getSavedFilter.error = action.error.message as string
            })

            .addCase(postFilter.pending, (state) => {
                state.postFilter.loading = true
            })
            .addCase(postFilter.fulfilled, (state, action) => {
                state.postFilter.loading = false
                state.postFilter.value = action.payload
            })
            .addCase(postFilter.rejected, (state, action) => {
                state.postFilter.error = action.error.message as string
            })


            .addCase(deleteFilter.pending, (state) => {
                state.deleteFilter.loading = true
            })
            .addCase(deleteFilter.fulfilled, (state, action) => {
                state.deleteFilter.loading = false
                state.deleteFilter.value = action.payload
            })
            .addCase(deleteFilter.rejected, (state, action) => {
                state.deleteFilter.error = action.error.message as string
            })

            .addCase(filterProperties.pending, (state) => {
                state.filterProperties.loading = true
            })
            .addCase(filterProperties.fulfilled, (state, action) => {
                state.filterProperties.loading = false
                state.filterProperties.value = action.payload
            })
            .addCase(filterProperties.rejected, (state, action) => {
                state.filterProperties.error = action.error.message as string
            })


    }

})


export default orderSlice.reducer

